import { withI18n } from '@lingui/react'
import classNames from 'clsx'
import { arrayOf, string } from 'prop-types'

import { isMobile } from 'shared/utils/deviceClassUtils'
import InputToBeCopied, {
  INPUT_ID_DESKTOP,
  INPUT_ID_MOBILE,
} from 'views/components/molecules/InputToBeCopied'
import { i18nType } from 'views/utils/propTypes'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

import { getIcons } from './helpers'

const renderLink = ({ mobile, icon: { mobileUrl, url, label, id, Icon } }) => (
  <a
    href={mobile ? mobileUrl : url}
    target="_blank"
    rel="noopener noreferrer nofollow"
    className={`a-link a-link--rounded a-link--${id} a-link--no-underline`}
  >
    <Icon size="x-large" />
    <span className="a-visuallyhidden">{label}</span>
  </a>
)

const renderInputToBeCopied = ({ url, productId, i18n, mobile }) => {
  const inputId = mobile ? INPUT_ID_MOBILE : INPUT_ID_DESKTOP
  const finalUrl = mobile
    ? `${url}?campaign=share/copylink/mobile/${productId}`
    : `${url}?campaign=share/copylink/desktop/${productId}`

  return (
    <InputToBeCopied
      name="productLink"
      value={finalUrl}
      inputId={inputId}
      buttonText={i18n._('socialModal.button.copyLink')}
    />
  )
}

const SocialPopup = ({
  canonicalURL: url,
  productName,
  productId,
  productMedia,
  i18n,
}) => {
  const icons = getIcons({
    i18n,
    url,
    productId,
    productName,
    productMedia,
  })

  const { deviceClass } = usePublicConfig()
  const isMobileDevice = isMobile(deviceClass)

  return (
    <div className="u-margin--bottom@medium">
      <ul className="l-flex l-flex--shrink l-flex--wrap a-list-reset o-SocialPopup__icons-list">
        {icons.map((icon, index) => (
          <li
            key={icon.id}
            className={classNames('u-margin--bottom', {
              'u-margin--right': index < icons.length - 1,
            })}
            data-clientside-hook={icon.mobileOnly ? 'mobileOnly' : ''}
          >
            {renderLink({ icon, mobile: isMobileDevice })}
          </li>
        ))}
      </ul>
      <div>
        {renderInputToBeCopied({
          url,
          productId,
          i18n,
          mobile: isMobileDevice,
        })}
      </div>
    </div>
  )
}

SocialPopup.propTypes = {
  canonicalURL: string.isRequired,
  productName: string.isRequired,
  productId: string.isRequired,
  productMedia: arrayOf(string),
  i18n: i18nType.isRequired,
}

SocialPopup.defaultProps = {
  productMedia: [],
}

export default withI18n()(SocialPopup)
